<template>
        <div class="profile-box">
            <Empty v-if="!props.showInfos" style="margin-top: 20px;"></Empty>

            <div class="info-list" v-else>
                <div class="list-text" v-for="info in props.showInfos" v-show="info.value">
                    <div class="label">{{ info.label }}：</div>
                    <div class="text">{{ info.value }}</div>
                </div>
            </div>
        </div>
</template>

<script setup lang="ts">
import UserShowLayout from "@/Components/Layout/UserShowLayout.vue";
import {Empty} from "ant-design-vue";

const props = defineProps<{
    showInfos: any,
    showUser: any,
}>()

defineOptions({
    layout : UserShowLayout
})

</script>

<style lang="less">
@media screen and (max-width: 1400px) {
    .profile-box {
        padding: 0 150px 60px 150px !important;
    }
}
</style>

<style scoped lang="less">
.profile-box{
    display: flex;
    padding: 0 350px 60px 350px;
    .info-list{
        margin-top: 20px;
        height: 450px;
        .list-text{
            display: flex;
            margin-top: 30px;
            font-size: 14px;
            color: #2e2e2e;
        }
    }
}
</style>
